<div class="maintenance-wrapper" [ngClass]="{ 'qd': brokerId === '04' }">
  <div class="background-blobs">
    <div class="blob blob-1"></div>
    <div class="blob blob-2"></div>
    <div class="blob blob-3"></div>
  </div>

  <div class="maintenance-card">
    <div class="logo-container">
      @if (brokerId === '01') {
        <img src="assets/images/footer-logo.svg" alt="Chill Logo" class="logo logo-chill">
      } @else if (brokerId === '04') {
        <img src="assets/images/devil-logo.png" alt="Quote Devil Logo" class="logo logo-qd">
      }
    </div>
    
    <div class="content">
      <div class="icon-animation">
        <div class="gear gear-1">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/></svg>
        </div>
      </div>

      <h1>Under Maintenance</h1>
      <p>We're currently performing some scheduled maintenance to improve your experience.</p>
      <p>We'll be back online shortly. Thank you for your patience!</p>
    </div>

    <div class="footer">
      @if (brokerId === '01') {
        <p>&copy; {{currentYear}} Chill Insurance. All rights reserved.</p>
      } @else if (brokerId === '04') {
        <p>&copy; {{currentYear}} Quote Devil Insurance. All rights reserved.</p>
      }
    </div>
  </div>
</div>
